import { FormEvent } from 'react'
import { useNavigate } from 'react-router'
import { useUserInvite } from '../api/users'
import { Button } from '../components/button'
import { Input } from '../components/input'

export function UsersInvite() {
	const navigate = useNavigate()
	const { mutate, isPending } = useUserInvite()

	const onSubmit = (event: FormEvent<HTMLFormElement>) => {
		const form = event.currentTarget
		event.preventDefault()
		mutate(new FormData(form), {
			onSuccess: () => {
				form.reset()
				navigate('../')
			},
		})
	}

	return (
		<form className="space-y-4 m-auto max-w-[300px]" onSubmit={onSubmit}>
			<h3 className="text-md font-bold">Nový uživatel</h3>
			<Input label="E-mail" name="email" type="email" isRequired></Input>
			<Button type="submit" isPending={isPending} isDisabled={isPending}>
				Přidat
			</Button>
		</form>
	)
}
